import {trim} from './atUtils'

/**
 * @param {number | undefined} minFractionDigits
 *   Minimum digits in fractional part of the formatted result.
 *   Must be no larger than `precision`.
 *   If undefined, then equals to `precision`.
 *   Ignored if `trimTrailingZeros` is true.
 * 
 * Examples when precision == 4 and minFractionDigits == 2:
 *   1       => 1.00
 *   1.2     => 1.20
 *   1.23    => 1.23
 *   1.234   => 1.234
 *   1.2345  => 1.2345
 *   1.23456 => 1.2346
 */
function NumberFormatter(decimalSeparator, digitGroupingSymbol, precision, trimTrailingZeros, prefix, postfix, nullValue, minFractionDigits) {
    this.decimalSeparator = decimalSeparator;
    this.digitGroupingSymbol = digitGroupingSymbol;
    this.precision = precision;
    this.trimTrailingZeros = trimTrailingZeros;
    this.prefix = prefix !== undefined ? prefix : '';
    this.postfix = postfix !== undefined ? postfix : '';
    this.nullValue = nullValue || "";
    this.minFractionDigits = minFractionDigits !== undefined ? minFractionDigits : precision;
}

NumberFormatter.prototype.format = function(value) {
    if ((value == null) || (trim(value) === ""))
        return this.nullValue;

    var fixed = Number(value).toFixed(this.precision);
    var str;

    if (this.trimTrailingZeros) {
        str = Number(fixed).toString();
    } else if (this.minFractionDigits != this.precision) {
        var fixedWithMinimumDigits = Number(value).toFixed(this.minFractionDigits);
        if (Number(fixedWithMinimumDigits) == Number(fixed))
            str = fixedWithMinimumDigits;  // if no precision is lost then use the variant with minimum digits
        else
            str = Number(fixed).toString();  // else just trim zeros
    } else {
        str = fixed;
    }

    if (this.digitGroupingSymbol && this.digitGroupingSymbol != "") {
        var strParts = str.split('.');
        var str = strParts[0];
        var srtDec = strParts[1] ? this.decimalSeparator + strParts[1] : "";

        var sign = "";
        if (fixed < 0) {
            sign = str.charAt(0);
            str = str.substr(1);
        }

        strParts = str.split(/(?=(?:\d{3})+(?:\.|$))/g);
        str = strParts.join(this.digitGroupingSymbol);

        str = sign + str + srtDec;
    } else {
        if (this.decimalSeparator)
            str = str.replace(".", this.decimalSeparator);
    }

    return this.prefix + str + this.postfix;
};

NumberFormatter.prototype.normalize = function(text) {
    text = text.trim()

    // in case '-' is configured as decimal separator or digit grouping symbol,
    // we still need to treat the leading '-' as negative number sign

    var negative = false

    if (text[0] === '-') {
        text = text.substr(1)
        negative = true
    }

    if (this.digitGroupingSymbol !== '')
        text = text.split(this.digitGroupingSymbol).join('')

    text = text.replace(this.decimalSeparator, '.')
    text = text.replace(',', '.')

    if (negative)
        text = '-' + text

    return text
}

NumberFormatter.prototype.isNegativeValue = function(value) {
    if ((value == null) || (trim(value) === ""))
        return this.nullValue;
    var formatValue = Number(value).toFixed(this.precision);
    if (formatValue == 0 && (1 / formatValue) === -Infinity) formatValue = +0;
    return formatValue < 0;
}

export default NumberFormatter



// WEBPACK FOOTER //
// ./web/js/number_formatter.js